import React, { useState, useEffect, useRef, useCallback, useMemo, useContext } from 'react';
import { Dropdown } from 'react-bootstrap'

import Search from './Search';

import RenapoContext from '../../context/RenapoContext';

import '../../Styles/SearchCoordindaora.css'

const ServerRoute = "https://webfullerette.fuller.com.mx/"
//const ServerRoute = "https://localhost:44384/"

function SearchCoordinadora() {


    const [dataRenapo, setdataRenapo] = useContext(RenapoContext);
    const [dataCoordiandora, setdataCoordinadora] = useState([])
    const [search, setSearch] = useState(dataRenapo.CoordinadorName);
    const [showvalue, setShow] = useState(true)
    const searchInput = useRef(null)

    const handleSearch = useCallback((e) => {
        setSearch(searchInput.current.value);
    }, [])


    const filtereCoordinadoras = useMemo(() =>
        dataCoordiandora.filter((data) => {
            return (
                data.name.toLowerCase().includes(search.toLowerCase()) ||
                data.value.toString().includes(search.toLowerCase())
            )
        }),
        [dataCoordiandora, search]
    )
    const onClickCoord = (data) => {
        setSearch(data.name);
        setdataRenapo(item => ({ ...item, CoordinadoraData: data.value, CoordinadorName: data.name }))
    }

    const currentData = filtereCoordinadoras.slice(0, 20);

    useEffect(() => {
        const FetchCoordinadora = () => {
            fetch(ServerRoute + "Service/GetCoordinadoras")
                .then(response => {
                    response.json()
                        .then(
                            (result) => {
                                if (result.code === 200) {
                                    setdataCoordinadora(result.data);
                                }
                                else {
                                    console.log("Error", result)
                                }
                            },
                        )
                })
        }
        FetchCoordinadora()
    }, [])

    useEffect(() => {
        if (search.length > 10 || filtereCoordinadoras.length === 0) {
            setShow(false)
        }
        else {
            setShow(true)
        }
    }, [search, filtereCoordinadoras])

    return (
        <div>
            <Search search={search} searchInput={searchInput} handleSearch={handleSearch} />
            <Dropdown.Menu show={showvalue}>
                <Dropdown.Header>Seleccione a la coordinadora que la refirió.</Dropdown.Header>
                {
                    currentData.map((item, i) =>
                        <Dropdown.Item key={i} onClick={() => { onClickCoord(item) }} eventKey={i}>{item.value} - {item.name}</Dropdown.Item>
                    )
                }
            </Dropdown.Menu>
        </div>
    )
}

export default SearchCoordinadora;